import api from "../../../services/axiosConfig";
import createModuleApi from "../../../services/createModuleApi";

const crud = createModuleApi("/instances/skeye/skeyepredict");

export const fetchUsers = crud.fetchAll;
export const createUser = crud.create;
export const updateUser = crud.update;
export const deleteUser = crud.remove;

export const updateUserRole = async (userId, role) => {
  const res = await api.put(
    `/instances/skeye/skeyepredict/update-user-role/${userId}`,
    {},
    { params: { role } },
  );
  return res.data;
};

export const updateUserAccess = async (userId, accessData) => {
  const res = await api.put(
    `/instances/skeye/skeyepredict/update-user-model-access/${userId}`,
    {
      hasPredictAccess: accessData.predict,
      hasEedaAccess: accessData.eeda,
      hasKbaseAccess: accessData.kbase,
    },
  );
  return res.data;
};
